var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0H4ZM6.77666 21C7.1146 21 7.38853 20.7279 7.38853 20.3922V9.54619C7.38853 9.21048 7.1146 8.93837 6.77666 8.93837H4.17208C3.83414 8.93837 3.56021 9.21048 3.56021 9.54619V20.3922C3.56021 20.7279 3.83414 21 4.17208 21H6.77666ZM3 5.45799C3 6.81548 4.10783 7.91597 5.47437 7.91597C6.84097 7.91597 7.94874 6.81548 7.94874 5.45799C7.94874 4.10049 6.84091 3 5.47437 3C4.10783 3 3 4.10049 3 5.45799ZM20.4374 21C20.7481 21 21 20.7498 21 20.4411V15.1919V15.1531C21.0001 12.8631 21.0004 8.75637 16.5503 8.75637C14.5292 8.75637 13.5801 9.4913 12.9413 10.4435V9.49723C12.9413 9.1886 12.6894 8.93837 12.3788 8.93837H9.67561C9.36493 8.93837 9.11303 9.1886 9.11303 9.49723V20.4411C9.11303 20.7498 9.36493 21 9.67561 21H12.3788C12.6895 21 12.9413 20.7498 12.9413 20.4411V14.5734C13.0115 13.7849 13.3609 12.0281 15.0834 12.0281C17.1404 12.0281 17.0997 14.2306 17.0825 15.1583C17.0811 15.2321 17.0799 15.2978 17.0799 15.3538V20.4411C17.0799 20.7498 17.3318 21 17.6425 21H20.4374Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.59008144.svg";
export { ForwardRef as ReactComponent };